import React from "react";

/**
 * A small collapse/expand icon button for panel corners.
 * @param {"left"|"right"|"up"|"down"} collapseDirection - Which direction the panel collapses toward
 * @param {boolean} isCollapsed - Whether the panel is currently collapsed
 * @param {function} onClick - Toggle collapse callback
 * @param {string} position - CSS positioning classes (e.g. "top-2 right-0")
 * @param {string} title - Tooltip text
 */
const CollapseButton = ({ collapseDirection, isCollapsed, onClick, position = "", title = "" }) => {
  // Arrow points toward the collapse direction when expanded, away when collapsed
  const getArrow = () => {
    const dir = isCollapsed ? oppositeDir(collapseDirection) : collapseDirection;
    switch (dir) {
      case "left":
        return (
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        );
      case "right":
        return (
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        );
      case "up":
        return (
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
        );
      case "down":
        return (
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        );
      default:
        return null;
    }
  };

  return (
    <button
      onClick={onClick}
      title={title || (isCollapsed ? "Expand panel" : "Collapse panel")}
      className={`absolute ${position} z-30 flex items-center justify-center
        w-5 h-5 rounded bg-ag-black-600 hover:bg-ag-black-400
        text-gray-400 hover:text-gray-200 transition-colors duration-150
        border border-ag-black-400 shadow-sm`}
      style={{ lineHeight: 0 }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width={12} height={12}>
        {getArrow()}
      </svg>
    </button>
  );
};

const oppositeDir = (dir) => {
  switch (dir) {
    case "left": return "right";
    case "right": return "left";
    case "up": return "down";
    case "down": return "up";
    default: return dir;
  }
};

export default CollapseButton;
